// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"layout"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M21 21V10L3 10L3 21L21 21Z"},"nodeName":"path","children":[]},{"attributes":{"id":"fill2","fill":"transparent","d":"M21 3L3 3L3 10L12 10L21 10V3Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M21 10V21H3V10M21 10H3M21 10V3H3V10M21 10H12M3 10H12M12 10V21","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-layout')
export default class LayoutIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'layout',
    }
  }
}
